<template>
  <div class="main-contain">
    <div class="module-title">
      <div class="main-title-text title-box pl10">
        机组水力性能对比({{ timeMap[timeType] }})
      </div>
    </div>
    <div class="handle-box">
      <div class="legend-box">
        <div class="legend rate">1号机组</div>
        <div class="legend f">2号机组</div>
        <div class="legend water">3号机组</div>
      </div>
    </div>
    <div
      class="chart-box"
      @click="showDialog"
    >
      <bar-chart
        id="bar"
        ref="barChartRef"
      ></bar-chart>
    </div>
    <model-one-dialog
      title="机组水力性能对比"
      ref="modelOneDialogRef"
      width="25%"
      modelType="modelFour"
      @refresh="getDataByParams"
    />
  </div>
</template>

<script>
import { api } from '@/api/api'
import BarChart from './echartComponents/BarChart.vue'
import ModelOneDialog from './dialogComponents/ModelOneDialog.vue'
export default {
  components: { BarChart, ModelOneDialog },
  data() {
    return {
      timeType: 1,
      timeMap: {
        1: '日',
        2: '周',
        3: '月',
        4: '季',
        5: '年',
      }
    }
  },
  mounted() {
  },
  methods: {
    getDataByParams(params) {
      this.timeType = params.unitTrendAnalysisTimeType
      this.$http.get({ url: api.unitHydraulicComparison }).then(res => {
        res.data.list.forEach(v => {
          if (!v) v = []
        })
        let dataList = res.data.list
        this.setData(dataList)
      })
    },
    showDialog() {
      this.$refs.modelOneDialogRef.show('ModelOneDetail')
    },
    setData(dataList) {
      this.$refs.barChartRef.initChart(dataList)
    },
    setTitle(setting) {
      this.timeType = setting.unitHydraulicComparisonTimeType
    }
  }
}
</script>

<style scoped lang="scss">
.main-contain {
  height: 100%;
  width: 100%;
  .module-title {
    padding-top: 20px;
    height: 10%;
    width: 100%;
    .title-box {
      display: flex;
      // &:before {
      //   content: url('@/assets/img/arrow.png');
      //   width: 30px;
      //   height: 30px;
      // }
    }
  }
  .handle-box {
    height: 10%;
    // margin-bottom: 20px;
    margin-top: 15px;
    .legend-box {
      display: flex;
      justify-content: center;
      .legend {
        color: #fff;
        position: relative;
        font-size: 15px;
        &:nth-child(1) {
          margin-right: 30px;
        }
        &:nth-child(2) {
          margin-right: 30px;
        }
        &.rate:before {
          content: '';
          position: absolute;
          left: -20px; /* 将圆形置于文本左侧 */
          top: 50%;
          transform: translateY(-50%); /* 垂直居中对齐 */
          width: 12px; /* 圆形的宽度 */
          height: 12px; /* 圆形的高度 */
          background-color: #fec200; /* 圆形的背景颜色 */
          border-radius: 50%; /* 创建圆形 */
        }
        &.f:before {
          content: '';
          position: absolute;
          left: -20px; /* 将圆形置于文本左侧 */
          top: 50%;
          transform: translateY(-50%); /* 垂直居中对齐 */
          width: 12px; /* 圆形的宽度 */
          height: 12px; /* 圆形的高度 */
          background-color: #17c5fd; /* 圆形的背景颜色 */
          border-radius: 50%; /* 创建圆形 */
        }
        &.water:before {
          content: '';
          position: absolute;
          left: -20px; /* 将圆形置于文本左侧 */
          top: 50%;
          transform: translateY(-50%); /* 垂直居中对齐 */
          width: 12px; /* 圆形的宽度 */
          height: 12px; /* 圆形的高度 */
          background-color: #1770fd; /* 圆形的背景颜色 */
          border-radius: 50%; /* 创建圆形 */
        }
      }
    }
  }
  .chart-box {
    height: 70%;
  }
}
</style>
